import { IListPageRequest, IListPageResponse } from "types/globalTypes";
import { asDemoLocale } from "./demoLocale";
import { applyMockItemFilters, extractSearchQuery, MockPageInfo } from "./mockFilterHelpers";

export type MockListPageOptions<T> = {
  search?: (item: T, search: string) => boolean;
  filters?: Array<(item: T, pageInfo: MockPageInfo) => boolean>;
};

export const createMockListPage = <T>(
  items: T[],
  pageInfo: IListPageRequest & Record<string, unknown>,
  options?: MockListPageOptions<T> | ((item: T, search: string) => boolean)
): IListPageResponse<T> => {
  const normalizedOptions: MockListPageOptions<T> =
    typeof options === "function" ? { search: options } : (options ?? {});

  const mockPageInfo = pageInfo as MockPageInfo;
  // Localize before search so EN queries match EN display names.
  const localizedItems = asDemoLocale(items);
  let filteredItems = normalizedOptions.filters?.length
    ? applyMockItemFilters(localizedItems, mockPageInfo, normalizedOptions.filters)
    : localizedItems;

  const search = extractSearchQuery(mockPageInfo);
  if (search && normalizedOptions.search) {
    filteredItems = filteredItems.filter((item) =>
      normalizedOptions.search!(item, search)
    );
  }

  return {
    Items: filteredItems,
    pageNumber: pageInfo.pageNumber ?? 1,
    pageSize: pageInfo.pageSize ?? 50,
    HasNextPage: false,
    HasPreviousPage: false,
  };
};
